import {
  cameraConfig,
  gameConfig
} from '@/app/config'
import {
  cameraManager,
  fpsManager
} from '@powerplay/core-minigames'
import {
  game,
  THREE
} from '@powerplay/core-minigames'
import { player } from '../athlete/player'

/**
 * Draha letu ostepu
 */
export class FlightPath {

  /** draha */
  private path?: THREE.QuadraticBezierCurve3

  /** akutalne percento */
  private actualPercent = 0

  /** Kolko percent je 1 meter na krivke */
  public oneMeterInPercent = 0

  /** callback na konci drahy */
  private endPathCallback: () => unknown = () => undefined


  public creatNewPath(start: THREE.Vector3, center: THREE.Vector3, end: THREE.Vector3): void {

    this.path = new THREE.QuadraticBezierCurve3(
      start,
      center,
      end
    )
    if (gameConfig.debugFlighPath) this.debugCurve()
    const totalPathLength = this.path?.getLength() || 0

    // takisto este potrebujeme 1m kolko je %
    this.oneMeterInPercent = 1 / totalPathLength

  }

  private debugCurve(): void {

    if (this.path === undefined) return

    const points = this.path.getPoints( 50 )
    const geometry = new THREE.BufferGeometry().setFromPoints( points )

    const material = new THREE.LineBasicMaterial( { color: 0xff0000 } )

    // Create the final object to add to the scene
    const curveObject = new THREE.Line( geometry, material )
    game.scene.add(curveObject)

  }

  /**
   * Vracia novy bod
   * @param speed - rychlost
   * @returns novy bod
   */
  public getNextPoint(speed: number): THREE.Vector3 | undefined {

    if (this.path === undefined) return undefined

    this.actualPercent += this.oneMeterInPercent * (speed / fpsManager.fpsLimit)

    // aktualizacia zoomu podla % na krivke
    if (player.javelin.wasThrown && player.javelin.javelinObjectFlying) {

      const percent = this.actualPercent > 1 ? 1 : this.actualPercent
      const camera = cameraManager.getMainCamera()
      const { start, end } = cameraConfig.javelinFlight.zoom
      camera.zoom = start + ((end - start) * percent)
      camera.updateProjectionMatrix()

    }

    if (this.actualPercent > 1) {

      this.endPathCallback()
      return this.path.getPointAt(1)

    }
    return this.path.getPointAt(this.actualPercent)

  }

  public getLookAtPoint(): THREE.Vector3 | undefined {

    if (this.path === undefined || this.actualPercent + 0.001 > 1) return undefined

    return this.path.getPointAt(this.actualPercent + 0.001)

  }

  /**
   * Setter
   * @param callback - end path callback
   */
  public setEndPathCallback(callback: () => unknown): void {

    this.endPathCallback = callback

  }

  /**
   * reset
   */
  public reset(): void {

    this.actualPercent = 0
    this.oneMeterInPercent = 0

  }

}